<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 24 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9 3C11.3439 3 13.25 4.90614 13.25 7.25C13.24 9.55196 11.4419 11.4097 9.15234 11.4902H9.12402C9.04482 11.4818 8.96348 11.4833 8.88672 11.4893C6.53765 11.4032 4.75 9.54362 4.75 7.25C4.75 4.90614 6.65614 3 9 3Z"
    [attr.fill]="color"
    stroke="black"
  />
  <path
    d="M9.0127 13.7549C10.6639 13.7549 12.2901 14.1481 13.5547 14.9092L13.8027 15.0654C14.8867 15.7881 15.4582 16.7127 15.5322 17.6719L15.54 17.8643C15.5385 18.8306 15.0294 19.7687 14.0107 20.5264L13.8008 20.6748C12.4999 21.5481 10.7628 22 9 22C7.3472 22 5.71651 21.6033 4.44727 20.834L4.19824 20.6748L4.19727 20.6738L3.98633 20.5264C2.96805 19.7762 2.45996 18.8377 2.45996 17.8799C2.45996 16.8575 3.03905 15.8478 4.20801 15.0654L4.20703 15.0645C5.5135 14.2003 7.25236 13.7549 9.0127 13.7549Z"
    [attr.fill]="color"
    stroke="black"
  />
  <path
    d="M16.1531 5.06738C17.7857 4.92578 19.2514 6.10161 19.4744 7.72461L19.4919 7.88281C19.6285 9.54855 18.4523 11.0001 16.8269 11.21H16.8103C16.7843 11.21 16.6845 11.2057 16.5701 11.2305C15.9446 11.2547 15.366 11.1088 14.8787 10.8301C15.6864 9.90447 16.1524 8.68551 16.1238 7.36914L16.1082 7.06055V7.05664L16.0681 6.72363C15.9832 6.16971 15.8092 5.64981 15.5671 5.1748C15.7549 5.12223 15.9526 5.08629 16.1541 5.06836L16.1531 5.06738Z"
    [attr.fill]="color"
    stroke="black"
  />
  <path
    d="M15.6511 13.5151C17.2265 13.4202 18.8822 13.8082 20.071 14.6226L20.3757 14.8491H20.3767C21.1526 15.4732 21.5163 16.1974 21.5007 16.9028L21.4919 17.0435V17.0483C21.433 17.7628 21.0012 18.4314 20.1794 18.9331L20.0095 19.0317H20.0085C19.3887 19.3726 18.6471 19.5925 17.864 19.6909C18.1627 19.2195 18.3586 18.7038 18.4363 18.1626L18.4578 17.9761L18.4587 17.9702C18.5678 16.6175 17.9632 15.356 16.8357 14.3569L16.6033 14.1606L16.6003 14.1577L16.3259 13.9507C16.1098 13.7948 15.884 13.6505 15.6511 13.5151Z"
    [attr.fill]="color"
    stroke="black"
  />
</svg>
